// constants/params.js
export const SIGNIN_MODIFIER = 'Admin'
export const REFRESH_TOKEN = 'refreshToken'
export const ACCESS_TOKEN = 'token_obtain'
